const config = process.env.CI
  ? {
      hegbotUrl: "http://localhost/api",
      clipCrudUrl: "http://localhost/soundboard/",
      youtube2mp3Url: "http://localhost/yt2mp3/",
    }
  : {
      hegbotUrl: "https://api.heg.cool/api",
      clipCrudUrl: "https://api.heg.cool/hegbot/soundboard/",
      youtube2mp3Url: "http://some.shit",
    };

export default config;
